import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Select from 'react-select';
import Scroll from 'react-scroll';
import FormControl from 'react-bootstrap/FormControl';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

//import CKEditor from 'react-ckeditor-component';

import Const from '../../../util/Constants';
import UserAPI from '../../../api/UserAPI';
import Util from '../../../util/Util';
import withRouter from '../../../util/WithRouter';
import Themes from '../../../util/Themes';
import ApiUiController from '../../../controller/ApiUiController';
import FieldText from '../../common/FieldText';
import FieldPassword from '../../common/FieldPassword';
import FieldEmail from '../../common/FieldEmail';
import FieldPhone from '../../common/FieldPhone';
import FieldSelect from '../../common/FieldSelect';
import ValidationController from '../../../controller/ValidationController';

class UserUpdate extends React.Component {
  constructor(props) {
    super(props);
    const models = reactLocalStorage.getObject(Const.Model);
    this.model = models.user;
    this.zones = models.zone.options;
    this.id = parseInt(props.match.params.userId);
    this.state = {
      user: {
        id: 0, name: '', img_id: '', work_email: '', work_phone: '',
        personal_phone: '', username: '', password: '', role: 0, reporting: 0, signature: '',
        theme: 1, dashboard: 0, zone: '', email: {
          from: '', host: '', port: '', secure: false,
          auth: { user: '', pass: '' }
        }
      }, inValid: {}, inApiCall: this.id !== 0
    };

    this.model.fields.theme.options = Themes;
    this.base = this.props.match.path;
    this.base = this.base.substring(0, this.base.indexOf('/add-edit'));

    if (this.id !== 0) {
      this.model.fields.username.editable = Const.False;
      this.model.fields.password.form_mandate = Const.False;
    }
  }
  componentDidMount() { if (this.id !== 0) { UserAPI.get(this.id, this.onReceived, this.onFail); } }
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = user => {
    if (user.zone && user.zone.includes(Const.Opt)) user.zone =
      this.zones.find(zone => parseInt(user.zone.split(Const.Opt)[0]) === zone.value);
    if (user.email_config) user.email = JSON.parse(user.email_config);
    this.setState({
      ...this.state,
      user: { email: { ...this.state.user.email }, ...user, password: '' },
      inApiCall: false
    });
  };

  onValueChange = (field, text) => {
    const user = { ...this.state.user };
    user[field] = text;
    this.setState({ ...this.state, user: { ...user }, inValid: {} });
  };
  onChange = selection =>
    this.setState({ ...this.state, user: { ...this.state.user, zone: selection } });

  onMailChange = (field, val) => {
    const email = { ...this.state.user.email };
    if (field.includes('.')) {
      const fields = field.split('.');
      email[fields[0]][fields[1]] = val;
    } else email[field] = val;
    this.setState({ ...this.state, user: { ...this.state.user, email: { ...email } } });
  };

  onReg = async () => {
    //await GoogleOauth2.authenticate(this.id);
  };

  onSave = () => {
    const inValid = ValidationController.validate(this.model.fields, this.state.user);
    if (inValid === null) {
      this.setState({ ...this.state, inApiCall: true });
      const user = { ...this.state.user };
      if (user.zone) user.zone = `${user.zone.value}${Const.Opt}${user.zone.time}`;
      user.email_config = JSON.stringify(user.email);
      UserAPI.save(user, this.onSaved, this.onFail);
    } else {
      Scroll.scroller.scrollTo(Object.keys(inValid)[0], { duration: 1500, smooth: true });
      const message = Util.failure(inValid);
      Util.showError(message);
      this.setState({ ...this.state, inValid: { ...inValid } });
    }
  };

  onSaved = () => {
    Util.showNotification('Successful', 'User saved successfully', 'success');
    this.props.navigate(this.base);
  };

  render() {
    return (
      <div className="sectionform pt-4">
        <div className="container form-cont">
          <div className="row"> <div className="col-md-12"> <h3>User</h3> </div> </div>
          <ApiUiController inApiCall={this.state.inApiCall}>
            <Form className="row row-cols-3 lead-form">

              <div className="formhead col-md-12"><h4>Information</h4></div>

              <FieldText key="name" id="name"
                field={this.model.fields.name} value={this.state.user.name}
                onValueChange={this.onValueChange} inValid={this.state.inValid} />

              <FieldEmail key="work_email" id="work_email"
                field={this.model.fields.work_email} value={this.state.user.work_email}
                onValueChange={this.onValueChange} inValid={this.state.inValid} />

              <FieldPhone key="work_phone" id="work_phone"
                field={this.model.fields.work_phone} value={this.state.user.work_phone}
                onValueChange={this.onValueChange} inValid={this.state.inValid} />

              <FieldPhone key="personal_phone" id="personal_phone"
                field={this.model.fields.personal_phone} value={this.state.user.personal_phone}
                onValueChange={this.onValueChange} inValid={this.state.inValid} />

              <div className="formhead col-md-12"><h4>Access Control</h4></div>

              <FieldText key="username" id="username"
                field={this.model.fields.username} value={this.state.user.username}
                onValueChange={this.onValueChange} inValid={this.state.inValid} />

              <FieldPassword key="password" id="password"
                field={this.model.fields.password} value={this.state.user.password}
                onValueChange={this.onValueChange} inValid={this.state.inValid} />

              <FieldSelect key="role" id="role" field={this.model.fields.role}
                value={this.state.user.role} onValueChange={this.onValueChange}
                inValid={this.state.inValid} />

              <FieldSelect key="reporting" id="reporting" field={this.model.fields.reporting}
                value={this.state.user.reporting} onValueChange={this.onValueChange}
                inValid={this.state.inValid} />

              <div className="formhead col-md-12"><h4>Signature</h4></div>
              {/*
              <div className="col-md-12">
                <CKEditor activeClass="p10" content={this.state.user.signature}
                  events={{ "change":
                    evt => this.onValueChange('signature', evt.editor.getData()) }} />
              </div>
              */}

              <div className="formhead col-md-12"><h4>Theme</h4></div>
              <FieldSelect key="theme" id="theme" field={this.model.fields.theme}
                value={this.state.user.theme} onValueChange={this.onValueChange}
                inValid={this.state.inValid} />
              <FieldSelect key="dashboard" id="dashboard" field={this.model.fields.dashboard}
                value={this.state.user.dashboard} onValueChange={this.onValueChange}
                inValid={this.state.inValid} />

              <div className="formhead col-md-12"><h4>Time Zone</h4></div>
              <div className="col">
                <div className="form-group">
                  <Select value={this.state.user.zone} onChange={this.onChange}
                    options={this.zones} isSearchable={true} />
                </div>
              </div>

              <div className="formhead col-md-12"><h4>Email Configuration</h4></div>
              <div className="col">
                <div className="form-group">
                  <label>From Mail Id</label>
                  <FormControl type="text" value={this.state.user.email.from}
                    className="mr-sm-2"
                    onChange={event => this.onMailChange('from', event.target.value)} />
                </div>
              </div>

              <div className="col">
                <div className="form-group">
                  <label>Host</label>
                  <FormControl type="text" value={this.state.user.email.host}
                    className="mr-sm-2"
                    onChange={event => this.onMailChange('host', event.target.value)} />
                </div>
              </div>

              <div className="col">
                <div className="form-group">
                  <label>Port</label>
                  <FormControl type="number" value={this.state.user.email.port} className="mr-sm-2"
                    onChange={event => this.onMailChange('port', event.target.value)} />
                </div>
              </div>

              <div className="col">
                <div className="form-group checkInline">
                  <label>Secure</label>
                  <Form.Check onChange={() => this.onMailChange('secure', true)}
                    checked={this.state.user.email.secure} /> <label>Yes</label>
                  <Form.Check onChange={() => this.onMailChange('secure', false)}
                    checked={!this.state.user.email.secure} /> <label>No</label>
                </div>
              </div>

              <div className="col">
                <div className="form-group">
                  <label>Username</label>
                  <FormControl type="text" value={this.state.user.email.auth.user}
                    className="mr-sm-2"
                    onChange={event => this.onMailChange('auth.user', event.target.value)} />
                </div>
              </div>

              <div className="col">
                <div className="form-group">
                  <label>Password</label>
                  <FormControl type="password" value={this.state.user.email.auth.pass}
                    className="mr-sm-2"
                    onChange={event => this.onMailChange('auth.pass', event.target.value)} />
                </div>
              </div>
              {/*
              <Google
                url={'http://localhost:3001'}
                clientId={Config.googleapi.client_id}
                clientSecret={Config.googleapi.client_secret}
                redirectUri={'http://localhost:3000'}
                scope={['https://www.googleapis.com/auth/userinfo.email']}
                width={300}
                height={300}
                callback={this.google}
                style={{ color: 'green' }} >
                Login With Google
              </Google>
    */}

              <div className="col-md-12 text-center btnsend">
                <Button variant="success" onClick={this.onSave}>Save</Button>
              </div>
            </Form>
          </ApiUiController>
        </div>
      </div>
    );
  }
}
export default withRouter(UserUpdate);
